module.exports = __webpack_public_path__ + "img/noheart - 複製.bc024d1a.png";